/**
 * Formats a timestamp to a localized date string
 * @param timestamp - Unix timestamp in milliseconds
 * @returns Formatted date string in pt-BR format (DD/MM/YYYY HH:MM) or "N/A" if invalid
 */
export const formatDate = (timestamp?: number): string => {
  if (!timestamp) return "N/A";
  return new Date(timestamp).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
